export const LEARNING_PATH_OPEN_INFORMATION_FORM = 'LEARNING_PATH_OPEN_INFORMATION_FORM';
export const LEARNING_PATH_TOGGLE_INFORMATION_FORM = 'LEARNING_PATH_TOGGLE_INFORMATION_FORM';
export const LEARNING_PATH_SUBMITTED_INFORMATION_FORM = 'LEARNING_PATH_SUBMITTED_INFORMATION_FORM';
export const LEARNING_PATH_SHOWN_INFORMATION_FORM = 'LEARNING_PATH_SHOWN_INFORMATION_FORM';
